import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { Row, Col, Label, FormGroup, DefaultTooltip, DefaultCheckbox } from 'twyne-new.ui'

import Input from 'components/form/Input';

import List from './List'

const propTypes = {
  forms: PropTypes.object,
  formOptions: PropTypes.array,
  mobileFormOptions: PropTypes.array,
  onChange: PropTypes.func,
  required: PropTypes.bool,
};

export default function SelectForm({ forms, formOptions, mobileFormOptions, onChange, required }) {
  const [activeMobile, setActiveMobile] = useState(false)

  const { desktop, mobile } = forms || {}
  const value = desktop?.length ? desktop[0].id : null

  useEffect(() => {
    setActiveMobile(![null, undefined].includes(mobile))
  }, [mobile])

  const handleChangeActiveMobile = checked => {
    if (!checked) onChange({ ...forms, mobile: null })
    setActiveMobile(checked)
  }

  const handleChange = (deviceKey, formValues) => {
    onChange({ ...forms, [deviceKey]: formValues })
  }

  return <Row id="select-form">
    <Col size="12">
      <FormGroup>
        <List label='Desktop' device="desktop" data={desktop} options={formOptions} onChange={handleChange} />
        {required ? <Input required name="_" type="hidden" value={value} /> : null}
      </FormGroup>
    </Col>
    <Col size="12">
      <FormGroup>
        <List
          label={<InputLabel onActiveMobile={handleChangeActiveMobile} activeMobile={activeMobile} />}
          device="mobile" options={mobileFormOptions} onChange={handleChange}
          data={activeMobile ? mobile : desktop} disabled={!activeMobile} />
      </FormGroup>
    </Col>
  </Row>
}

function InputLabel({ onActiveMobile, activeMobile }) {
  return <Label>
    <DefaultTooltip content='Override Form'>
      <DefaultCheckbox
        id='override'
        value={activeMobile}
        onChange={onActiveMobile}
      >
        Mobile
      </DefaultCheckbox>
    </DefaultTooltip>
  </Label>
}

SelectForm.propTypes = propTypes
SelectForm.defaultProps = {}
